import React from "react";

import { Spinner } from "@/components/ui";

export const LoadingView = () => {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-3">
      <Spinner />
      <span>Loading...</span>
    </div>
  );
};
